/**
 * @file Route: brandsingle
 *
 * This file is compiled as a standalone entrypoint and it is included by
 * default in its blade template.
 * This is a "standard" route, it does not have a structure to follow, you are
 * sure the DOM is always ready and the JS will only be executed in this route.
 */

import "./index.scss";
import "layouts/main";
import List from "list.js";
import { ProductCard } from "components/Product/Card"
import { initWishlist, wishlistOn } from "@olmokit/core/wishlist"

import Alpine from 'alpinejs';

import { $, $all, forEach, on, addClass, removeClass } from "@olmokit/dom";

import { post } from "@olmokit/core/fragments/ajax";
import LazyLoad from "@olmokit/core/lazy";
import { render } from "@olmokit/utils/render";

import { globalData } from "@olmokit/core/data";

console.log("Route brandsingle/index.js mounted.");

initWishlist();
ProductCard();

/**
 * Search, sort and filter lists and tables
 * @requires https://listjs.com/
 */

(() => {
  const filterListContainers = document.querySelectorAll('[data-filter-list]');
  if (filterListContainers.length === 0) return;

  // Clear button functions
  const createClearButton = (container, searchField) => {
    const clearButton = document.createElement('button');
    clearButton.className = 'btn btn-sm btn-outline-secondary w-auto border-0 p-1 position-absolute top-50 end-0 translate-middle-y me-2 opacity-0';
    clearButton.innerHTML = `
          <svg class="opacity-75" width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
            <path d="M18.619 5.381a.875.875 0 0 1 0 1.238l-12 12A.875.875 0 0 1 5.38 17.38l12-12a.875.875 0 0 1 1.238 0Z"/><path d="M5.381 5.381a.875.875 0 0 1 1.238 0l12 12a.875.875 0 1 1-1.238 1.238l-12-12a.875.875 0 0 1 0-1.238Z"/>
          </svg>
        `;
    container.appendChild(clearButton);
    updateClearButtonVisibility(searchField, clearButton);
    return clearButton;
  };
  const updateClearButtonVisibility = (searchField, clearButton) => {
    clearButton.classList.toggle('opacity-0', searchField.value === '');
  };
  const clearSearchField = (searchField, clearButton) => {
    searchField.value = '';
    updateClearButtonVisibility(searchField, clearButton);
  };

  // Init list filtering
  /* eslint-disable no-unused-vars, no-undef */
  [...filterListContainers].map(filterListsEl => {
    const options = JSON.parse(filterListsEl.dataset.filterList);
    const searchFields = filterListsEl.querySelectorAll('.' + options.searchClass);
    if (searchFields.length) {
      const clearButton = createClearButton(searchFields[0].parentNode, searchFields[0]);
      searchFields.forEach(searchField => {
        searchField.addEventListener('input', () => {
          updateClearButtonVisibility(searchField, clearButton);
        });
      });
      clearButton.addEventListener('click', () => {
        searchFields.forEach(searchField => {
          clearSearchField(searchField, clearButton);
        });
        filterList.search();
      });
    }
    const filterList = new List(filterListsEl, options);
    return filterList;
  });
  /* eslint-enable no-unused-vars, no-undef */
})();

const $product = $("#card-product");

const renderCardProduct = render($product.innerHTML);

Alpine.store('filters', {
  items: { 'category': [], 'macrocategory': [] },
  params: [],

  addParams(value) {
    let url = new URL(window.location.href);
    let params = new URLSearchParams(url.search.slice(1));
    params.append(value.prop, value.id);
    window.history.replaceState({}, "", `${location.pathname}?${params}`);
  },

  removeParams(value) {
    let url = new URL(window.location.href);
    let params = new URLSearchParams(url.search.slice(1));
    params.delete(value.prop, value.id);
    window.history.replaceState({}, "", `${location.pathname}?${params}`);
  },

  add(value, type) {
    this.items[type].push(value);
    
    this.filter();
  },

  remove(value, type) {
    const array = this.items[type].filter(e => e.id != value.id);
    this.items[type] = array;

    this.filter();
  },

  check(id, label, type) {

    const property = {
      id: id,
      label: label
    };

    console.log('property', property);

    if (this.search(property.id, this.items[type])) {
      this.remove(property, type);
    } else {
      this.add(property, type);
    }

  },

  search(nameKey, myArray) {
    return myArray.find(item => item.id === nameKey) || null;
  },

  removeButton(value, type) {
    this.remove(value, type);
    this.removeCheck(value, type);
  },

  removeCheck(value, type) {
    const check = $('.' + type + '-' + value.id);
    check.checked = false;
  },

  removeAll() {
    for (const [key, value] of Object.entries(this.items)) {
      value.forEach((e) => {
        
        this.items.category = []
        this.items.macrocategory = []

        this.removeCheck(e, key);
      });
    }
    console.log(this.items.category.length, this.items.macrocategory.length);
    if (this.items.category.length == 0 && this.items.macrocategory.length == 0) {
      this.filter();
    }    

  },

  loadingPage() {
    let url = window.location.href;
    let urlUrl = new URL(url);
    let params = new URLSearchParams(urlUrl.search.slice(1));

    const $radio = $all(".Filters:property_value.radiox input.formControl");

    for (let p of params) {

      forEach($radio, (el) => {

        const prop = el.getAttribute('data-value');

        if (idType != p[0]) {
          const value = { id: p[1], label: 'none', prop: p[0] };
          this.removeParams(value)
        } else if (prop == p[1]) {
          const id = el.getAttribute('data-value');
          const label = el.getAttribute('data-name');
          const property = el.getAttribute('data-property');
          const value = { id: id, label: label, prop: property };

          el.checked = true;
          this.add(value);
        }
      });

    }

    if (this.items.length > 0) {
      this.filter();
    }
  },

  filter() {

    // let queryValues = {};

    const queryCategory = this.items.category.map((e) => {
      return e.id
    });

    const queryMacroCategory = this.items.macrocategory.map((e) => {
      return e.id
    });

    const loader = $('.loader');

    loader.style.display = 'flex';

    post('filters', {
      data: {
        id: '',
        idpage: '1',
        category: queryCategory,
        macrocategory: queryMacroCategory,
        brands: globalData.idbrand,
        offset: "1000"
      },
    }).then(({ data }) => {
      // console.log(data);
      // debugger;

      const $products = $("#card-products");

      $products.innerHTML = renderCardProduct({
        results: data.elements
      });

      const $productFound = $("#productFound");

      $productFound.innerHTML = data.count

      loader.style.display = 'none';

    });
  }
});

Alpine.start();